var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home",attrs:{"id":"home"}},[_c('navigationBar',{attrs:{"showBack":_vm.showBack,"home":_vm.home}},[_vm._v("首页")]),_c('banner'),_c('evaluationPictureIndex'),_c('tabBar',{attrs:{"active":0}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }